export default __webpack_public_path__ + "static/1394-0fa0445bfc9927896a95fd4b604c02ff.gif";